import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CModalHeader, CRow } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'

const TripleCardCarouselModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { isEdit, type, cardIndex } = modalSpecificData

  const { userSessionObj } = useContext(GlobalContext)

  const [title, setTitle] = useState('')
  const intialCardState = {
    image_s3key: '',
    heading: '',
    link: {
      type: '',
      data: {},
    },
  }
  const [cardAData, setCardAData] = useState(intialCardState)
  const [cardBData, setCardBData] = useState(intialCardState)
  const [cardCData, setCardCData] = useState(intialCardState)
  const [errorData, setErrorData] = useState({})
  const [cardAImageData, setCardAImageData] = useState([])
  const [cardBImageData, setCardBImageData] = useState([])
  const [cardCImageData, setcardCImageData] = useState([])
  const { loader, setLoader } = useContext(AppContext)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const cardAImgData = [
      {
        title: '',
        id: 'cardAImgData',
        width: 657,
        height: 385,
        divheight: '11.9rem',
        divwidth: '20.5rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('cardAImg')
          setCardAData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardAData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '10px',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        btnMarginTop: '4px',
      },
    ]
    const cardBImgData = [
      {
        title: '',
        id: 'cardBImgData',
        width: 305,
        height: 172,
        divheight: '5.5rem',
        divwidth: '9.69rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setCardBData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardBData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        uploadIconflexRow: true,
        uploadIconsize: '10px',
        btnMarginTop: '2px',
      },
    ]
    const cardCImgData = [
      {
        title: '',
        id: 'cardCImgData',
        width: 305,
        height: 172,
        divheight: '5.5rem',
        divwidth: '9.69rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setCardCData((prev) => ({ ...prev, image_s3key: obj?.s3Key }))
        },
        onRemoveImg: () => {
          setCardCData((prev) => ({ ...prev, image_s3key: '' }))
        },
        imageUrl: '',
        titleDisabled: true,
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        imgUploaderBg: '#f5f5f5',
        uploadIconflexRow: true,
        uploadIconsize: '10px',
        btnMarginTop: '2px',
      },
    ]
    if (isEdit) {
      if (type === 'HEADING') {
        setTitle(componentData?.data?.title)
        return
      }

      console.log('modalSpecificData?.modalData', modalSpecificData?.modalData)

      setCardAData(modalSpecificData?.modalData?.image_a)
      setCardBData(modalSpecificData?.modalData?.image_b)
      setCardCData(modalSpecificData?.modalData?.image_c)

      cardAImgData[0]['assetId'] = modalSpecificData?.modalData?.image_a?.image_s3key
      cardAImgData[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        modalSpecificData?.modalData?.image_a?.image_s3key,
      )

      cardBImgData[0]['assetId'] = modalSpecificData?.modalData?.image_b?.image_s3key
      cardBImgData[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        modalSpecificData?.modalData?.image_b?.image_s3key,
      )

      cardCImgData[0]['assetId'] = modalSpecificData?.modalData?.image_c.image_s3key
      cardCImgData[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        modalSpecificData?.modalData?.image_c.image_s3key,
      )
    }

    setCardAImageData(cardAImgData)
    setCardBImageData(cardBImgData)
    setcardCImageData(cardCImgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (title.trim().length === 0 && type === 'HEADING') {
      isFormValid = false
      temp.title = 'Heading cannot be Empty!'
    }

    if (type === 'CARD' && cardAData.image_s3key.trim().length === 0) {
      isFormValid = false
      temp.cardAImg = 'Please Upload Image-A!'
    }

    if (type === 'CARD' && cardAData.link.type && !validateLink(cardAData.link).isValid) {
      isFormValid = false
      temp.cardALink = validateLink(cardAData.link).error
    }
    if (type === 'CARD' && cardBData.link.type && !validateLink(cardBData.link).isValid) {
      isFormValid = false
      temp.cardBLink = validateLink(cardBData.link).error
    }
    if (type === 'CARD' && cardCData.link.type && !validateLink(cardCData.link).isValid) {
      isFormValid = false
      temp.cardCLink = validateLink(cardCData.link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let tempdata = componentData.data
    if (type === 'CARD') {
      let elementObj = {
        image_a: cardAData,
        image_b: cardBData,
        image_c: cardCData,
      }

      if (!isEdit) {
        tempdata?.card_data.splice(cardIndex + 1, 0, elementObj)
      } else {
        tempdata?.card_data.splice(cardIndex, 1, elementObj)
      }

      modifyData(componentData.id, tempdata)
      return
    }

    tempdata['title'] = title

    modifyData(componentData.id, tempdata)
  }

  let multiAccordionItems = [
    {
      title: 'Add text to Image-A',
      description: 'Specify elements under the card which contain Image-A.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading (A)</h6>
            <CustomDescriptionBox
              limit={45}
              rows={1}
              value={cardAData.heading}
              onChange={(value) => setCardAData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={cardAData.link}
              id={'cardAData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardALink')
                setCardAData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.cardALink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-3',
    },
    {
      title: 'Add text to Image-B',
      description: 'Specify elements under the card which contain Image-B.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading (B)</h6>
            <CustomDescriptionBox
              limit={38}
              rows={1}
              value={cardBData.heading}
              onChange={(value) => setCardBData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={cardBData.link}
              id={'cardBData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardBLink')
                setCardBData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.cardBLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add text to Image-C',
      description: 'Specify elements under the card which contain Image-C.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Heading (C)</h6>
            <CustomDescriptionBox
              limit={38}
              rows={1}
              value={cardCData.heading}
              onChange={(value) => setCardCData((prev) => ({ ...prev, heading: value }))}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-1">
            <AttachLink
              linkData={cardCData.link}
              id={'cardCData'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                clearError('cardCLink')
                setCardCData((prev) => ({ ...prev, link: value }))
              }}
              astrick={true}
            />
            <div className="message-text error-message">
              <p>{errorData.cardCLink}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <CModal size="lg" className="" alignment={type === 'CARD' ? '' : 'center'} visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      {type === 'CARD' && (
        <CModalHeader style={{ borderBottom: 0 }} className="d-flex justify-content-center">
          <p>
            <b style={{ fontWeight: '500', fontSize: '1.3rem' }}>Add New card to Slider</b>
          </p>
        </CModalHeader>
      )}

      {type === 'CARD' ? (
        <CModalBody style={{ height: '75vh' }} className="px-5 static-scrollbar-class">
          <CRow className="">
            <CCol>
              <h6 className="font-13px">
                Upload images to the individual cards <span style={{ color: 'red' }}>*</span>
              </h6>

              <div
                style={{ fontSize: '12px' }}
                className="mt-2 d-flex justify-content-between w-100"
              >
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div
                    className="d-flex flex-column  justify-content-center align-items-center"
                    style={{ width: '22.489rem', height: '21.6935rem', background: '#dbdbdb' }}
                  >
                    <div>
                      <span style={{ fontWeight: 500 }}>Image - A </span>
                      <span style={{ fontSize: '10px' }}> ( 657px X 385px )</span>

                      {cardAImageData && <ImageUploader data={cardAImageData} />}
                    </div>
                    <div
                      style={{ width: '20.5rem' }}
                      className="d-flex justify-content-between mt-2 "
                    >
                      <div>
                        <span style={{ fontWeight: 500 }}>Image - B </span>
                        <span style={{ fontSize: '10px' }}> ( 305px X 172px )</span>
                        {cardBImageData && <ImageUploader data={cardBImageData} />}
                      </div>
                      <div>
                        <span style={{ fontWeight: 500 }}>Image - C </span>
                        <span style={{ fontSize: '10px' }}> ( 305px X 172px )</span>
                        {cardCImageData && <ImageUploader data={cardCImageData} />}
                      </div>
                    </div>
                  </div>
                  <div className="message-text error-message">
                    <p>{errorData.cardAImg}</p>
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <TemplateAccordion items={multiAccordionItems} styles={''} />
          </CRow>
        </CModalBody>
      ) : (
        <CModalBody className="px-5">
          <div style={{ fontSize: '1.3rem' }} className="d-flex justify-content-center">
            <p>
              <b style={{ fontWeight: '500' }}>Text Editor</b>
            </p>
          </div>
          <CRow className="my-3 mt-5">
            <CCol>
              <h6 className="font-13px">Component Heading</h6>
              <CustomDescriptionBox
                limit={40}
                rows={1}
                value={title}
                onChange={setTitle}
                style={{ fontSize: '13px' }}
              />
            </CCol>
          </CRow>
        </CModalBody>
      )}

      <CModalFooter style={{ borderTop: 0 }} className="px-5">
        <CButton
          style={{ color: 'black', border: '1px solid black' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleSave}>
          Save
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default TripleCardCarouselModal
